import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'options'],
  watch: {
    data: function (newVal, oldVal) { // watch it
      this.renderChartData(newVal, this.options)
    }
  },
  methods: {
    update () {
      this.$data._chart.update()
    },
    renderChartData: function (data, options) {
      this.renderChart(data, options)
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  }
}
